import { render, staticRenderFns } from "./WebCallPage.vue?vue&type=template&id=3666ed02&"
import script from "./WebCallPage.vue?vue&type=script&lang=js&"
export * from "./WebCallPage.vue?vue&type=script&lang=js&"
import style0 from "./WebCallPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports